import { Subscription } from "./subscription";
import { UserSubscriptionAddOn } from "./user-subscription-addon";

export class CurrentUser {

	firstName: string;
	lastName: string;
	name: string;
	email: string;
	profileImage: string;
	has_open_payments: boolean;
	payment_uri: string | null;
	subscription: Subscription;
	subscription_addons: UserSubscriptionAddOn[];
}